import { render, staticRenderFns } from "./MealsMealsChart.vue?vue&type=template&id=f994e05a"
import script from "./MealsMealsChart.vue?vue&type=script&lang=js"
export * from "./MealsMealsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports